"use client";

import type { UseQueryResult } from "@tanstack/react-query";
import type { Token } from "@/lib/api/transfers";
import { formatAmount } from "@/lib/format/amount";

/* The connected wallet's holding of the deposit token, under the wallet
   card the way the whitelabel's WalletBalance sits under the address: the
   figure a player is about to spend from, refreshed while the panel is
   open. The wallet keeps its ticker — this is the one place the site talks
   in tokens, because tokens are what the wallet holds. */
export function WalletBalance({
  balance,
  token,
}: {
  balance: UseQueryResult<bigint | null>;
  token: Token;
}) {
  return (
    <p className="mb-[4px] flex items-center justify-between gap-[8px] px-[2px] text-[12px] leading-[1.6] text-fg-subtle">
      <span>Wallet balance on {token.network.name}</span>
      {balance.isPending ? (
        <span className="h-[14px] w-[72px] animate-pulse rounded bg-elevation-3" aria-label="Reading the balance" />
      ) : balance.data === null || balance.data === undefined ? (
        <span title="The balance could not be read on this network right now">Unavailable</span>
      ) : (
        <span className="font-bold tabular-nums text-fg">
          {formatAmount(balance.data.toString(), token)} {token.symbol}
        </span>
      )}
    </p>
  );
}
